
import React, { useState } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Paper,
  AppBar,
  Toolbar,
  Alert,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import apiService from "../components/ReasuableFuncations/api";

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openLoadingDialog, setOpenLoadingDialog] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setSuccess(null);

    // Validate passwords
    if (newPassword !== confirmPassword) {
      setError("New passwords do not match");
      return;
    }

    if (newPassword.length < 6) {
      setError("New password must be at least 6 characters long");
      return;
    }

    setLoading(true);
    setOpenLoadingDialog(true);

    try {
      const response = await apiService.post("/api/change-password", {
        currentPassword,
        newPassword,
      });

      if (response.data.success) {
        setSuccess("Password changed successfully!");
        setTimeout(() => {
          navigate("/home");
        }, 2000);
      } else {
        setError(response.data.message || "Failed to change password");
      }
    } catch (error) {
      setError(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
      setOpenLoadingDialog(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundImage: "url(./background.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <AppBar
        position="static"
        sx={{ backgroundColor: "transparent", boxShadow: "none" }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Box display="flex" alignItems="center">
            <img
              src="./l2.png"
              alt="COMESA Logo"
              style={{ maxWidth: "50px", marginRight: "16px" }}
            />
            <Typography variant="h6">Portal</Typography>
          </Box>
          <Button color="inherit" component={Link} to="/home">
            Home
          </Button>
        </Toolbar>
      </AppBar>

      <Container
        maxWidth="md"
        sx={{
          marginBottom: "0px",
          paddingRight: "24px",
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          elevation={20}
          sx={{
            p: 4,
            bgcolor: "rgba(255, 255, 255)",
            width: "80%",
            maxWidth: "600px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              component="h1"
              variant="h5"
              sx={{ my: 2, fontWeight: "bold" }}
            >
              Change Password
            </Typography>

            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{ mt: 1, width: "100%" }}
            >
              {error && <Alert severity="error">{error}</Alert>}
              {success && <Alert severity="success">{success}</Alert>}

              <TextField
                margin="normal"
                required
                fullWidth
                name="currentPassword"
                label="Current Password"
                type="password"
                id="currentPassword"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />

              <TextField
                margin="normal"
                required
                fullWidth
                name="newPassword"
                label="New Password"
                type="password"
                id="newPassword"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />

              <TextField
                margin="normal"
                required
                fullWidth
                name="confirmPassword"
                label="Confirm New Password"
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                disabled={loading || !currentPassword || !newPassword || !confirmPassword}
              >
                Change Password
              </Button>
            </Box>
          </Box>
        </Paper>
      </Container>

      <Dialog
        open={openLoadingDialog}
        onClose={() => setOpenLoadingDialog(false)}
      >
        <DialogTitle>Changing Password</DialogTitle>
        <DialogContent sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </DialogContent>
      </Dialog>

      <Box
        component="footer"
        sx={{
          backgroundColor: "#333",
          color: "#fff",
          padding: "10px",
          textAlign: "center",
        }}
      >
        <Typography variant="body2">
          ©️ {new Date().getFullYear()} EA-SA-IO ICT M&E Portal. All rights
          reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default ChangePassword;